import {BRAND} from "../context/ColorModeContext";

type Props = {
    size?: number;
    color?: string;
};

// Logo mark from bitlab.kz
const BitlabLogo = ({size = 34, color = BRAND.accent}: Props) => {
    return (
        <svg width={size} height={size} viewBox="0 0 67 66" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
                d="M33.3333 0C14.9233 0 0 14.7741 0 33C0 51.2259 14.9233 66 33.3333 66C51.7433 66 66.6667 51.2259 66.6667 33C66.6667 14.7741 51.7433 0 33.3333 0ZM51.3333 40.2963C51.3333 42.3819 50.21 44.3058 48.3867 45.3486L37.6133 51.5064C35.79 52.5492 33.5433 52.5492 31.72 51.5064L20.9467 45.3486C19.1233 44.3058 18 42.3819 18 40.2963V13.3617C18 12.2694 18.8967 11.3817 20 11.3817H26C27.1033 11.3817 28 12.2694 28 13.3617V38.0985H41.3333V31.4985H34.6667V15.3285C35.4 15.4176 36.7 16.2492 37.6133 16.7706L48.3867 22.9284C50.21 23.9712 51.3333 25.8984 51.3333 27.9807V40.2963Z"
                fill={color}
            />
        </svg>
    );
};

export default BitlabLogo;
